import React, { useState, useEffect, createRef } from "react";
import {
  makeStyles,
  Button,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  withStyles,
  Slide,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import ReportPrintBudgetAdjustmentRequisition from "src/components/reports/ReportPrintBudgetAdjustmentRequisition";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 600,
    padding: 1,
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
    lineHeight: "5ch",
    alignContent: "center",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    overflowX: "auto",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PrintBudgetRequisitionModalComponent({
  open,
  handleClose,
  isLoading,
  data,
}) {
  const classes = useStyles();
  const [src, setSrc] = useState();

  useEffect(() => {
    if (open) {
      ReportPrintBudgetAdjustmentRequisition(data).getDataUrl(function (
        outDoc
      ) {
        setSrc(outDoc);
      });
    }
    return () => {};
  }, [open]);

  return (
    <div className={classes.modal}>
      <Dialog
        fullScreen
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        TransitionComponent={Transition}
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Print Budget Requisition
        </DialogTitle>
        <DialogContent dividers>
          <div
            style={{ minHeight: "80vh", height: "90vh", overflow: "hidden" }}
          >
            <iframe src={src} height="100%" width="100%" />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
